export const FETCH_USER_REQUEST = 'user/FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'user/FETCH_USER_SUCCESS';

export const fetchUserRequest = (payload = {}) => ({
  type: FETCH_USER_REQUEST,
  payload,
});
export const fetchUserSuccess = (payload = {}) => ({
  type: FETCH_USER_SUCCESS,
  payload,
});
